import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Col, notification, Row, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { StepsPage } from '../structure'
import { FINISH_ROUTE_PATH, UPLOAD_ROUTE_PATH } from '../App'
import { useUploadProcess } from '../context/UploadProcessProvider'
import { HTMLText, InfoRectangle } from '../components/common'
const { Paragraph, Title } = Typography

const STEP_NUMBER = 0

const UploadConfirmation = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = parseInt(params.id)
  const submission_id = parseInt(params.submission_id)
  const { steps, data, setValues, deleteFile, getFile } = useUploadProcess()
  const showWarning = (msg) => {
    notification.warning({
      message: <HTMLText html={msg} />,
      placement: 'bottomLeft',
    })
  }

  const navigate = useNavigate()

  useEffect(() => {
    if (!data.file && id && submission_id)
      getFile(
        id,
        submission_id,
        (result) => {
          if (result)
            setValues({ id: id, submission_id: submission_id, file: result })
        },
        () => {
          setValues({ id: null, submission_id: null })
          showWarning(`File <strong>${id}</strong> is not found`)
          navigate(UPLOAD_ROUTE_PATH)
        }
      )
  }, [])

  const handleFileReplace = () => {
    deleteFile(
      () => {
        setValues({ id: null })
        navigate(UPLOAD_ROUTE_PATH)
      },
      () => {
        notification.error({
          message: t(
            'Sorry, an error happened while replacing the file. Please reload the page'
          ),
          placement: 'bottomLeft',
        })
      }
    )
  }

  return (
    <StepsPage step={STEP_NUMBER} title={t('TextUploaded.ThankYouUpload')}>
      {data.file ? (
        <InfoRectangle img="images/common/confirmation.webp">
          <FileInformation
            filename={data.file.file_name}
            showReplaceBtn={steps[1] !== true || data.draft}
            onReplace={handleFileReplace}
            onNextStep={() => {
              navigate('contract')
            }}
          />
        </InfoRectangle>
      ) : (
        <div>Loading...</div>
      )}
    </StepsPage>
  )
}
export default UploadConfirmation

const FileInformation = ({
  filename,
  showReplaceBtn,
  onReplace,
  onNextStep,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Title level={3}>{t('TextUploaded.Great')}</Title>
      <Paragraph>{t('TextUploaded.SuccessfullyUploaded')}</Paragraph>
      <Row justify="center" gutter={10}>
        <Col>
          <Paragraph className="paragraph-sb petrol-text">
            [{filename}]
          </Paragraph>
        </Col>
        {showReplaceBtn && (
          <Col>
            <Button type="link" onClick={onReplace} className="small-button">
              {t('TextUploaded.Replace.button')}
            </Button>
          </Col>
        )}
      </Row>
      <Paragraph className="mb0">
        <strong>{t('TextUploaded.WhatHappensNext')}</strong>
      </Paragraph>
      <Paragraph className="center paragraph-s">
        {t('TextUploaded.AcceptContract')}
      </Paragraph>
      <Button type="primary" onClick={onNextStep}>
        {t('TextUploaded.Continue.button')}
      </Button>
    </>
  )
}
